import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import Message from 'element-ui/lib/message' // ⚡ 路径导入，避免全量 element-ui 进初始 chunk
import { getToken, removeToken } from '@/utils/auth' // 验权

const whiteList = ['/login', '/oidc-callback', '/swagger', '/usermanager/profile'] // 不重定向白名单
router.beforeEach((to, from, next) => {

  // ⚡ 白名单路由 + 未登录 → 直接放行，不等 GetIdentityAuth API
  // 这样登录页在 JS 执行完的瞬间就能渲染，省掉一个网络往返
  if (whiteList.indexOf(to.path) !== -1 && !getToken()) {
    NProgress.start()
    NProgress.done()
    next()
    return
  }

  if (to.path === '/dashboard') {
    if (!JSON.parse(window.localStorage.getItem('department'))) {
      // 有 token 但模块未加载 → 需要先走认证+加载流程
      if (getToken() && store.getters.modules == null) {
        console.log('[Guard] /dashboard 有token无modules，走加载流程')
        NProgress.start()
        store.dispatch('GetIdentityAuth').then(isIdentity => {
          if (!isIdentity) {
            store.dispatch('GetInfo').then(() => {
              return store.dispatch('GetModulesTree').then(modules => {
                window.localStorage.setItem('modules', JSON.stringify(modules))
                return store.dispatch('GenerateRoutes', { modules }).then(() => {
                  router.addRoutes(store.getters.addRouters)
                  next({ ...to, replace: true })
                })
              })
            }).catch((err) => {
              console.error('[Guard] /dashboard 加载模块失败:', err)
              // 加载失败仍然放行，避免卡死
              next()
            })
          } else {
            next()
          }
        }).catch(() => {
          next()
        })
      } else {
        next()
      }
      return
    } else {
      if (!JSON.parse(window.localStorage.getItem('Currentdepartment')) || !JSON.parse(window.localStorage.getItem('routers'))) {
        next('/orginfo')
        return
      } else {
        next()
        return
      }
    }
  }


  // ⚡ 非白名单路由：正常走认证流程
  // 完整 Element UI 随 Layout.vue 异步加载，无需在此等待
  NProgress.start()
  store.dispatch('GetIdentityAuth').then(isIdentity => {


    if (isIdentity) { // 采用Identity认证
      // ⚠️ 延迟注册 oidcStore（含 oidc-client ~260KB），仅在 Identity 认证时才加载
      store.registerOidcModule().then(() => {

      // 如果是oidcRedirect必须进入授权
      // 没登录时，如果是白名单页面，可以直接访问
      // 没登录时，如果是非登录页面，则跳转到登录
      if (store.getters.oidcUser == null && to.path !== '/oidcRedirect') {
        if (whiteList.indexOf(to.path) !== -1) {
          next()
          return
        } else {
          next('/login')
          return
        }
      }

      store.dispatch('oidcCheckAccess', to).then(function (hasAccess) {
        if (!hasAccess) {
          return
        }
        if (to.path === '/login') { // 登录后login自动跳转
          next({ path: '/' })
          return
        }
        if (store.getters.modules != null) {
          next()
          return
        }
        return store.dispatch('GetModulesTree').then(modules => { // 获取用户可访问的模块
          window.localStorage.setItem('modules', JSON.stringify(modules))
          return store.dispatch('GenerateRoutes', { modules }).then(() => { // 根据权限生成可访问的路由表
            // store.dispatch('GetDefaultOrg')
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
        })

      })

      }) // end registerOidcModule().then()
    } else { // 普通登录方式

      if (getToken()) {

        if (to.path === '/login') { // 登录后login自动跳转       
          next({ path: '/' })
          return
        }
        if (store.getters.modules != null) {
          next()
          return
        }
        store.dispatch('GetInfo').then(() => { // 拉取用户信息
          return store.dispatch('GetModulesTree').then(modules => { // 获取用户可访问的模块
            window.localStorage.setItem('modules', JSON.stringify(modules))
            return store.dispatch('GenerateRoutes', { modules }).then(() => { // 根据权限生成可访问的路由表
              // store.dispatch('GetDefaultOrg')
              router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            })
          })
        }).catch((err) => {
          console.error('[Guard] ❌ 加载路由失败，踢回登录:', err)
          store.dispatch('FedLogOut').then(() => {
            Message.error((err && err.message || err) || '获取用户信息失败，请重试')
            next('/login')
          })

        })

        return
      }
      if (whiteList.indexOf(to.path) !== -1) { // 没登录情况下过滤白名单
        next()
      } else {

        next('/login')
      }
    }
  }).catch((err) => {
    Message.error(err || '获取服务器登录方式失败')
    NProgress.done()
    // 获取认证方式失败时，放行到白名单页面，否则跳转登录
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  })



})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
